export type { FavoritablePublicBoatCardProps } from './FavoritablePublicBoatCard';
export { FavoritablePublicBoatCard } from './FavoritablePublicBoatCard';
